/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import BackAction from './BackAction/index'
import CompleteAction from './CompleteAction/index'
import NextAction from './NextAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Actions"
  
}) {
let imageCaptureQuestionIdValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'id',
})
let constantData = 'welcome'
let aggregateData = fromAggregate.equals(imageCaptureQuestionIdValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--jc-1-AjnkD': aggregateData ? "end" : "space-between"}}
 className={`views-block ${styles.Horizontal}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
/>
<CompleteAction
  viewPath={`${viewPath}/CompleteAction`}
/>
</div>
{children}
</React.Fragment>)
}